import { TFunction } from 'i18next'
import { DataItem, navigateTo } from 'scrivito'

import { MenuItemProps } from '@/Atomic/Molecules/MenuItem'
import { DataItemNewTabLink } from '@/Components/shared/DataItemNewTabLink'
import { DownloadAnchor } from '@/Components/shared/DownloadAnchor'

interface BuildDocumentDrawerMenuItemsOptions {
  t: TFunction
  document?: DataItem
  downloadUrl?: string
  downloadName?: string
}

export const buildDocumentDrawerMenuItems = ({
  t,
  document,
  downloadUrl,
  downloadName,
}: BuildDocumentDrawerMenuItemsOptions): MenuItemProps[] => {
  if (!document) return []

  const items: MenuItemProps[] = [
    {
      icon: 'link-external',
      label: t('common.openInNewTab'),
      as: DataItemNewTabLink,
      dataItem: document,
    },
    {
      icon: 'file-empty',
      label: t('components.document.goToDocumentPage'),
      onClick: () => navigateTo(document),
    },
  ]

  if (downloadUrl) {
    items.unshift({
      icon: 'download-circle',
      label: t('common.download'),
      as: DownloadAnchor,
      url: downloadUrl,
      name: downloadName,
    })
  }

  return items
}
